import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useAppStore } from '@/lib/store';
import { getLaunchParams } from '@/lib/telegram';

let handled = false;

/** Bot xabarlaridagi tugmalar ochadigan sahifalar. */
const STATIC_LINKS: Record<string, { path: string; driverMode?: boolean }> = {
  admin: { path: '/admin' },
  driver_routes: { path: '/driver/routes', driverMode: true },
  driver_apply: { path: '/driver/apply', driverMode: true },
};

/**
 * `startapp` (SPEC §11): `order_<id>` → buyurtma sahifasi. t.me havolasida launch params'da,
 * bot `web_app` tugmalarida URL query'da (`?startapp=`) keladi.
 */
export function DeepLinkHandler() {
  const navigate = useNavigate();
  const setMode = useAppStore((s) => s.setMode);

  useEffect(() => {
    if (handled) return;
    handled = true;
    let param: string | undefined;
    try {
      param = getLaunchParams().tgWebAppStartParam;
    } catch {
      // Telegram tashqarisi.
    }
    param ??= new URLSearchParams(window.location.search).get('startapp') ?? undefined;
    if (!param) return;

    const order = param.match(/^order_([0-9a-f-]{36})$/i);
    if (order) {
      void navigate(`/orders/${order[1]}`);
      return;
    }
    const link = STATIC_LINKS[param];
    if (link) {
      if (link.driverMode) setMode('driver');
      void navigate(link.path);
    }
  }, [navigate, setMode]);

  return null;
}
